import React from "react";
import "./button.css";

const SIZE_CLASS = {
  default: "btn--default",
  lg: "btn--lg",
};

const VARIANT_CLASS = {
  default: "btn--outline", // se chamarem sem variant, fica discreto
  hero: "btn--hero",
  accent: "btn--accent",
  secondary: "btn--secondary",
  outline: "btn--outline",
};

export function Button({
  size = "default",
  variant = "default",
  className = "",
  ...props
}) {
  const classes = [
    "btn",
    SIZE_CLASS[size] || SIZE_CLASS.default,
    VARIANT_CLASS[variant] || VARIANT_CLASS.default,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <button className={classes} {...props} />;
}

export default Button;
